/**
 * Converts JS Error to string representation
 * for BI
 */
export const errorToString = (err: Error | string | unknown): string => {
  let errorReason = '';
  if (typeof err === 'object' && err !== null) {
    if ('message' in err && typeof (err as any).message === 'string') {
      errorReason = (err as any).message;
    } else if ('toString' in err && typeof (err as any).toString === 'function') {
      errorReason = (err as any).toString();
    } else {
      errorReason = JSON.stringify(err);
    }
    if (typeof (err as Error)?.stack === 'string') {
      errorReason += '\n' + (err as Error).stack;
    }
  } else if (typeof err === 'string') {
    errorReason = err;
  } else {
    errorReason = String(err);
  }
  return errorReason;
};
